import { WebFooter } from '@/components/web-footer'
import { SchoolWebTopHeader } from '@/components/web-top-header/SchoolWebTopHeader'
import { useClientOnly } from '@/hooks/useClientOnly'
import { SchoolLayout } from '../school'

interface Props {
  children: React.ReactNode
}

export const EnterpriseDetailLayout = ({ children }: Props): JSX.Element => {
  return (
    <SchoolLayout>
      <EnterpriseDetailLayoutInner>{children}</EnterpriseDetailLayoutInner>
    </SchoolLayout>
  )
}

function EnterpriseDetailLayoutInner(props: Props) {
  useClientOnly()
  return (
    <div className="grid-areas-enterprise-detail-layout">
      <SchoolWebTopHeader className="grid-area-header" />
      <article className="grid-area-content bg-basic-bg">
        {props.children}
      </article>
      <WebFooter className="grid-area-footer" />
    </div>
  )
}

export function getEnterpriseDetailLayout(page: React.ReactElement) {
  return <EnterpriseDetailLayout>{page}</EnterpriseDetailLayout>
}
